<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("MTax Report ") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-3 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getMunicipalityReportSummary('N', 'N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
          <!-- <div class="col-lg-8 col-xl-2 align-self-center mb-3">
            <div class="input_material">
              <b-form-input
                type="search"
                @input="onSearch"
                v-model="searchText"
                placeholder="Search Bill No"
              ></b-form-input>
            </div>
          </div> -->

          <div
            v-if="municipalityRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="excelDownload()"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <!-- <a
              target="_blank"
              @click="getMunicipalityReportSummary('N', 'Y')"
              title="Download as Pdf"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a> -->
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Show Date</th>
            <th>Cinema Name</th>
            <th>Admits</th>

            <th>M-Tax Amount</th>
          </thead>
          <tbody v-if="municipalityRecords.length > 0">
            <tr v-for="(item, index) in municipalityRecords" :key="index">
              <th>{{ item.ss_start_date }}</th>
              <th>{{ item.cinema_name }}</th>
              <th class="text-right">{{ item.admits }}</th>
              <th class="text-right">{{ currFormat(item.m_tax) }}</th>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <th colspan="2" class="text-right">Grand Total</th>
              <th class="text-right">
                {{
                  municipalityRecords.reduce((acc, { admits }) => {
                    return acc + admits;
                  }, 0)
                }}
              </th>
              <th class="text-right">
                {{
                  currFormat(
                    municipalityRecords.reduce((acc, { m_tax }) => {
                      return acc + m_tax;
                    }, 0)
                  )
                }}
              </th>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="5">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import { authenticationService } from "@/services/AuthenticationService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      distributorsList: [],
      movieTotal: [],
      selectedDistributor: {
        d_company_name: "",
        d_id: "",
      },
      selectedMovie: {
        movie_title: "",
        movie_id: "",
      },
      MovieList: [],
      municipalityRecords: [],
      excelFilePath: "",
      nepalMonth: {},
      grandTotal: {},
      disabledDates: {
        from: "",
      },
      searchText: "",
      voucherArray: ["With Voucher", "Without Voucher"],
      voucherValue: "Without Voucher",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.fromDate = new Date();
    Promise.all([this.getCinemaList()]).then(() => {});
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },

    excelFilePath(value) {
      this.excelFilePath = value;
    },
    fromDate: function (value) {
      this.disabledDates.from = new Date(
        moment(this.fromDate).format("YYYY"),
        parseFloat(moment(this.fromDate).format("MM")),
        1
      );
      this.toDate = moment(this.toDate).isAfter(value, "months")
        ? moment(this.fromDate).endOf("month").format("YYYY-MM-DD")
        : this.toDate;
    },
  },
  mounted() {},
  methods: {
    moment,
    excelDownload() {
      let temp_data = this.municipalityRecords;
      let loader = this.$loading.show();
      let data = [
        {
          sheet: "MTax Report",
          columns: [
            {
              value: (row) => (row.ss_start_date ? row.ss_start_date : "-"),
              label: "Show Date",
            },
            {
              value: (row) => (row.cinema_name ? row.cinema_name : "-"),
              label: "Cinema Name",
            },
            {
              value: (row) => (row.admits ? row.admits : 0),
              label: "Admits",
            },
            {
              value: (row) =>
                row.m_tax
                  ? +parseFloat(row.m_tax).toFixed(this.MIN_FRACTION_DIGITS)
                  : 0,
              label: "M-Tax Amount",
            },
          ],
          content: temp_data,
        },
      ];
      let from_daten = moment(this.fromDate).format("YYYY-MM-DD");
      let to_daten = moment(this.toDate).format("YYYY-MM-DD");
      let cinema_name = this.dropDown.selectedCinemaName || "";
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let settings = {
        // fileName: `MTax-Report ${new Date().getTime()}`
        fileName: `MTax-Report-${cinema_name}_${from_daten}_${to_daten}_on${dateTime}`,
      };
      xlsx(data, settings);
      loader.hide();
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getDistributorsList: function () {
      let body = {
        tableName: "ms_distributors",
        d_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;

          if (data && data.status && data.Records.length > 0) {
            this.distributorsList = data.Records;
          } else {
            this.$toasted.show("Failed to fetch distributor names");
          }
        })
        .catch((error) =>
          Vue.toasted.show(
            "Catch Error on MasterStore fetchDistributorsList",
            error
          )
        );
    },
    fetchDistributorMovies() {
      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show("Please Select Cinema");
        this.selectedDistributor = [];
        this.$forceUpdate();
      } else {
        this.MovieList = [];
        this.selectedMovie.movie_id = "";
        this.selectedMovie.movie_title = "";
        let payload = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          d_id: this.selectedDistributor.d_id,
          d_company_name: this.selectedDistributor.d_company_name,
          country_id: authenticationService.get("BRGLOPCO"),
          filter_with_key: "ss_actual_start_date",
          isVoucherShow: this.voucherValue == "With Voucher" ? "Y" : "N",
        };
        ReportsService.getDistributorMovieFormatV2(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              this.MovieList = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch((error) => {
            this.$toasted.show(
              "Catch Error on ReportStore fetchDistributorMovies",
              error
            );
          });
      }
    },
    getMunicipalityReportSummary(isExcel, isPdf) {
      if (isExcel == "N" || isPdf == "N") {
        this.municipalityRecords = [];
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        user_name: this.secureStore.get("USINFO").username,
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        d_name: this.selectedDistributor.d_company_name,
        d_id: this.selectedDistributor.d_id,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        movie_id: this.selectedMovie.movie_id,
        isExcel,
        isPdf,
        isVoucherShow: this.voucherValue == "With Voucher" ? "Y" : "N",
      };
      ReportsService.getMTaxReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.municipalityRecords = [...data.Records];
            this.grandTotal = { ...data.grandTotal };
            // this.movieTotal = [...data.movieTotal];
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
.movie_bg {
  background-color: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/MTaxReport.vue